'use strict';
import $ from 'jquery';

export default class ToggleTabs {
    static init() {
        $('.toggle-tabs').each((index, el) => {
            new ToggleTabs($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.on('click', 'ul.toggles li a', (e) => {
            let tab = $(e.currentTarget).attr('href').replace(/^#/, '');
            this.activateTab(tab);
            window.location.hash = tab;
        });
        this.tabs = [];
        this.el.find('ul.toggles li a').each((i, a) => {
            let tab = $(a).attr('href').replace(/^#/, '');
            this.tabs.push(tab);
            if (tab === window.location.hash.replace(/^#/, '')) {
                this.activateTab(tab);
            }
        });
        $(window).on('hashchange', (e) => {
            let tab = location.hash.substring(1);
            this.activateTab(tab);
            this.el.trigger('tab-changed', [tab]);
        });
    }

    activateTab(tab) {
        if (this.tabs.indexOf(tab) > -1) {
            this.el.find('ul.toggles li').removeClass('active');
            this.el.find('.tab').removeClass('show');
            this.el.find('ul.toggles li[data-target=' + tab + ']').addClass('active');
            this.el.find('.tab[data-tab=' + tab + ']').addClass('show');
        }
    }
}